export enum ProductCategories {
    Basic = 'Basic',
    Classic = 'Classic',
    Comfort = 'Comfort'
}